(() => {
  function initialize() {
    if (!document.querySelector('.dn-product-refined') || window.__dnProductChatCollision) return;
    window.__dnProductChatCollision = true;

    const targets = [
      '.dn-product-refined .product-form__buttons',
      '.dn-product-refined .product-bar__submit',
      '.dn-product-refined product-variant-selects select',
      '.dn-product-refined product-variant-selects summary',
      '.dn-product-refined .product-option__label',
      '.dn-product-refined [data-size-modal-open]',
      '[data-dn-size-modal].is-open [data-size-modal-dialog]',
      '.dn-product-refined .dn-policy-link',
      '.dn-product-refined .dn-product-condition',
      '.dn-product-refined .dn-product-arrival',
      '.dn-product-refined .dn-free-shipping',
      '.dn-product-refined .dn-fixed-color',
      '.dn-product-refined .dn-product-details p',
      '.dn-product-refined .dn-product-details li',
      '.dn-product-refined .dn-product-details__attribute',
      '.dn-product-refined .pickup-availability__drawer summary',
      '.dn-product-refined .dn-accordion__summary',
      '.dn-product-refined .dn-accordion[open] .dn-accordion__content p',
      '.dn-product-refined .dn-accordion[open] .dn-accordion__content :is(h2, h3, h4, h5, h6)',
      '.dn-product-refined .dn-accordion[open] .dn-accordion__content a',
      '.dn-product-refined .dn-accordion[open] .dn-accordion__content li',
      '.dn-product-refined [data-dn-review-carousel] [data-review-text]',
      '.section--product-recommendations a.button',
      '.section--product-recommendations button',
      '.cart-drawer__summary-actions',
      '.dn-product-refined [data-dn-review-carousel] button',
      '.dn-product-refined [data-dn-review-carousel] a'
    ].join(',');
    const observerOptions = {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'open']
    };
    let frame = 0;
    let hiddenLauncher = null;

    function restoreLauncher() {
      if (!hiddenLauncher) return;
      const { element, display, priority } = hiddenLauncher;
      if (element.style.getPropertyValue('display') === 'none' &&
          element.style.getPropertyPriority('display') === 'important') {
        if (display) element.style.setProperty('display', display, priority);
        else element.style.removeProperty('display');
      }
      hiddenLauncher = null;
    }

    function viewportBounds() {
      const viewport = window.visualViewport;
      return {
        left: viewport?.offsetLeft || 0,
        top: viewport?.offsetTop || 0,
        width: viewport?.width || window.innerWidth,
        height: viewport?.height || window.innerHeight
      };
    }

    function visibleRect(element, isLauncher = false) {
      if (!element?.isConnected || element.closest('[hidden]')) return null;
      if (!isLauncher && element.closest('[inert], [aria-hidden="true"]')) return null;
      const style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return null;
      const rect = element.getBoundingClientRect();
      const viewport = viewportBounds();
      const left = Math.max(rect.left, viewport.left);
      const top = Math.max(rect.top, viewport.top);
      const right = Math.min(rect.right, viewport.left + viewport.width);
      const bottom = Math.min(rect.bottom, viewport.top + viewport.height);
      return right > left && bottom > top ? { left, top, right, bottom } : null;
    }

    function hasCollision(launcherRect) {
      return Array.from(document.querySelectorAll(targets)).some((element) => {
        const rect = visibleRect(element);
        return rect && rect.left < launcherRect.right && rect.right > launcherRect.left &&
          rect.top < launcherRect.bottom && rect.bottom > launcherRect.top;
      });
    }

    function update() {
      frame = 0;
      observer.disconnect();
      try {
        const launcher = document.querySelector('#gorgias-chat-container #chat-button');
        if (hiddenLauncher && hiddenLauncher.element !== launcher) restoreLauncher();
        if (!document.querySelector('.dn-product-refined') || !launcher || launcher.contains(document.activeElement) ||
            visibleRect(document.querySelector('#gorgias-chat-container #chat-window'), true)) {
          restoreLauncher();
          return;
        }
        const viewport = viewportBounds();
        if (hiddenLauncher) {
          if (launcher.style.getPropertyValue('display') !== 'none' ||
              launcher.style.getPropertyPriority('display') !== 'important') {
            hiddenLauncher = null;
          } else if (Object.keys(viewport).some((key) => viewport[key] !== hiddenLauncher.viewport[key])) {
            restoreLauncher();
            schedule();
            return;
          } else {
            if (!hasCollision(hiddenLauncher.rect)) restoreLauncher();
            return;
          }
        }
        const launcherRect = visibleRect(launcher, true);
        if (!launcherRect) return;
        if (!hasCollision(launcherRect)) return;
        hiddenLauncher = {
          element: launcher,
          display: launcher.style.getPropertyValue('display'),
          priority: launcher.style.getPropertyPriority('display'),
          rect: launcherRect,
          viewport
        };
        launcher.style.setProperty('display', 'none', 'important');
      } catch {
        restoreLauncher();
      } finally {
        observer.observe(document.body, observerOptions);
      }
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    const observer = new MutationObserver(schedule);
    observer.observe(document.body, observerOptions);
    window.addEventListener('gorgias-widget-loaded', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('scroll', schedule, { passive: true, capture: true });
    document.addEventListener('load', schedule, true);
    document.addEventListener('transitionend', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
    document.fonts?.ready.then(schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
